module.exports = __webpack_public_path__ + "static/img/coupon.2e1813b8.png";